// extracted by mini-css-extract-plugin
export default {"wrap":"Services_wrap__BMlQR","particles":"Services_particles__eXA8i","map":"Services_map__7DI5Y","slides":"Services_slides__2ZLhe"};